import React, { useEffect, useState } from "react";
import Header from "../../comps/Header";
import Footer from "../../comps/Footer";
import {
  add_to_cart_list,
  remove_to_cart_list,
  user_update_to_cart,
  item_remove_to_cart_list,
} from "../../api/Product";
import { Link, useNavigate } from "react-router-dom";

const Cart = () => {
  const navigate = useNavigate();
  const [showEmptyMessage, setShowEmptyMessage] = useState(false);
  const [hasCheckedCart, setHasCheckedCart] = useState(false);
  const [cartList, setCartList] = useState({});
  console.log("cartList_cartList", cartList);
  const [quantity, setQuantity] = useState(1);
  const [pricePerItem, setPricePerItem] = useState(1.0);
  const [termsChecked, setTermsChecked] = useState(false);
  const [pricingChecked, setPricingChecked] = useState(false);
  const [error, setError] = useState(null);

  // <---------- User Authentication Token ------------>
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const fetchCartList = async () => {
    try {
      const response = await add_to_cart_list(headers);
      const product = response?.data?.data;
      console.log("Fetched product:", product);

      if (product) {
        setCartList(product);
        setQuantity(product.quantity);
        setPricePerItem(product.price);
      } else {
        setCartList({}); // Clear cart if empty
      }
    } catch (error) {
      console.error("Error fetching cart:", error);
    }
  };
  useEffect(() => {
    fetchCartList();
  }, []);

  const handle_remove_cart_list = async () => {
    try {
      const response = await remove_to_cart_list(headers); // Pass headers first, then id
      console.log("handle_remove_cart_list", response);
      fetchCartList();
    } catch (error) {
      console.log("error", error);
    }
  };

  const handle_item_remove_cart_list = async (itemId) => {
    try {
      const response = await item_remove_to_cart_list(itemId, headers);
      console.log("handle_remove_cart_list", response);
      fetchCartList();
    } catch (error) {
      console.log("error", error);
    }
  };

  const handle_update_to_cart_list = async (newQuantity, id) => {
    const data = {
      product_id: id,
      quantity: newQuantity,
    };
    try {
      const response = await user_update_to_cart(headers, data);
      console.log("user_update_to_cart", response);
    } catch (error) {}
  };

  // Function to update quantity in both state and cartList
  const updateQuantity = (newQuantity) => {
    setQuantity(newQuantity);
    setCartList((prev) => ({ ...prev, quantity: newQuantity }));
  };

  // // Function to increase quantity
  // const increaseQuantity = () => {
  //     if (!cartList || cartList.length === 0) return; // Prevent errors if cartList is empty

  //     const updatedCart = cartList.map((item, index) => {
  //         if (index === 0) {  // Only update the first item (Modify if needed)
  //             return { ...item, quantity: item.quantity + 1 };
  //         }
  //         return item;
  //     });

  //     setCartList(updatedCart); // Update state
  //     handle_update_to_cart_list(updatedCart[0].quantity); // Pass new quantity
  // };

  // // Function to decrease quantity (minimum 1)
  // const decreaseQuantity = () => {
  //     if (!cartList || cartList.length === 0) return; // Prevent errors if cartList is empty

  //     const updatedQuantity = cartList[0].quantity - 1; // Decrease quantity

  //     if (updatedQuantity < 1) {
  //         // If quantity is less than 1, remove the item from the cart
  //         handle_remove_cart_list();
  //     } else {
  //         // Otherwise, update the quantity
  //         const updatedCart = cartList.map((item, index) => {
  //             if (index === 0) {
  //                 return { ...item, quantity: updatedQuantity };
  //             }
  //             return item;
  //         });

  //         setCartList(updatedCart); // Update state
  //         handle_update_to_cart_list(updatedQuantity); // Call API to update quantity
  //     }
  // };

  // Function to increase quantity of a specific product
  const increaseQuantity = (index) => {
    const updatedCart = cartList.map((item, i) => {
      if (i === index) {
        const updatedItem = { ...item, quantity: (item.quantity || 1) + 1 };
        handle_update_to_cart_list(updatedItem.quantity, item?.product_id); // optional: pass index or id
        return updatedItem;
      }
      return item;
    });

    setCartList(updatedCart);
  };



  // Function to decrease quantity of a specific product
  const decreaseQuantity = (index) => {
    const updatedCart = cartList
      ?.map((item, i) => {
        if (i === index) {
          const newQty = (item.quantity || 1) - 1;
          if (newQty < 1) {
            handle_item_remove_cart_list(item?.id); // remove the item completely
            return null;
          } else {
            const updatedItem = { ...item, quantity: newQty };
            handle_update_to_cart_list(updatedItem.quantity, item?.product_id); // optional
            return updatedItem;
          }
        }
        return item;
      })
      .filter(Boolean); // remove nulls (if any item was removed)

    setCartList(updatedCart);
  };

  // Calculate total price
  // Calculate total price for all cart items
  const totalPrice = Array.isArray(cartList)
    ? cartList.reduce((total, item) => {
        let price = 0;

        if (item?.order_type === "development") {
          price = item?.development?.price || 0;
        } else if (item?.order_type === "product") {
          price = item?.product?.price || 0;
        } else {
          price = item?.domain_amount || 0;
        }

        return total + item?.quantity * price;
      }, 0)
    : 0;

  useEffect(() => {
    if (cartList && Object.keys(cartList).length === 0) {
      const timer = setTimeout(() => {
        setShowEmptyMessage(true);
        setHasCheckedCart(true);
      }, 2000); // 2 seconds delay
      return () => clearTimeout(timer);
    } else {
      setShowEmptyMessage(false);
      setHasCheckedCart(true);
    }
  }, [cartList]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCheckboxChange = (type, checked) => {
    if (type === "terms") setTermsChecked(checked);
    if (type === "pricing") setPricingChecked(checked);

    // Simple validation
    if (!checked || (!termsChecked && !pricingChecked)) {
      setError("Please accept both the Terms & Policies and the pricing.");
    } else if (checked && termsChecked && pricingChecked) {
      setError(null);
    }
  };

  const serviceTax = totalPrice * 0.0625;
const grandTotal = totalPrice + serviceTax;
  
  const handleBanxaCheckout = async () => {
    // console.log(totalPrice)
    // window.location.href = "https://locknpay.banxa-sandbox.com/papi/transit/?initId=eyJpdiI6IjNkZE1uMmZ2YURtVHA4VFBFST[…]GM3ZTJjOGNlMGNiYWFlZWFlNDU3ZTdhZjZhMjQiLCJ0YWciOiIifQ=="
    try {
      const response = await fetch("/api/banxa/create-order", {
        method: "POST",
        headers : { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({
          fiatCurrency: "USD",
          cryptoCurrency: "USDT",
          fiatAmount: totalPrice,
        }),
      });

      const data = await response.json();
      console.log(data);

      if (data.referral_url) {
          window.open(data.referral_url, "_blank");
        return;
      }
    //   if (!window.Banxa) {
    //     const script = document.createElement("script");
    //     script.src = "https://cdn.banxa.com/banxa-widget.js";
    //     script.onload = () => {
    //       window.Banxa?.open({ order: data });
    //     };
    //     document.body.appendChild(script);
    //   } else {
    //     window.Banxa.open({ order: data });
    //   }
    } catch (error) {
      console.error(error);
      alert("Banxa checkout failed");
    }
  };

  return (
    <>
      {/*  */}
      <Header />
      {Object.keys(cartList).length > 0 ? (
        <div className="max-w-6xl mx-auto p-6">
          <h2 className="text-2xl font-semibold mb-4">Shopping Cart</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="md:col-span-2 border p-4 rounded-lg shadow-md">
              <div className="flex items-center space-x-4">
                <div className="flex-1">
                  {cartList?.map((cartList_result, index) => (
                    <div key={index} className="mb-6 border-b pb-4">
                      {cartList_result?.product && (
                        <>
                          <h2 className="text-lg font-semibold">
                            {cartList_result?.product?.type}
                          </h2>
                          <h3 className="text-sm">
                            {cartList_result?.product?.title}
                          </h3>
                          <p className="text-gray-600">
                            ${cartList_result?.product?.price}
                          </p>
                          <p className="text-sm text-gray-500">
                            {cartList_result?.product?.billing_cycle}
                          </p>
                        </>
                      )}

                      {cartList_result?.development && (
                        <>
                          <h2 className="text-lg font-semibold">
                            {cartList_result?.development?.type}
                          </h2>
                          <h3 className="text-sm">
                            {cartList_result?.development?.title}
                          </h3>
                          <p className="text-gray-600">
                            ${cartList_result?.development?.price}
                          </p>
                        </>
                      )}

                      {cartList_result?.order_type === "domain" && (
                        <>
                          <h2 className="text-lg font-semibold">
                            {cartList_result?.order_type}
                          </h2>
                          <h3 className="text-sm">{cartList_result?.domain}</h3>
                          <p className="text-gray-600">
                            ${cartList_result?.domain_amount}
                          </p>
                        </>
                      )}

                      <div className="flex items-center mt-3">
                        <button
                          className="px-3 py-1 border rounded-l-lg bg-gray-200 hover:bg-gray-300"
                          onClick={() => decreaseQuantity(index)}
                        >
                          -
                        </button>
                        <span className="px-4 py-1 border-t border-b">
                          {cartList_result.quantity || 1}
                        </span>
                        <button
                          className="px-3 py-1 border rounded-r-lg bg-gray-200 hover:bg-gray-300"
                          onClick={() => increaseQuantity(index)}
                        >
                          +
                        </button>
                      </div>

                      <button
                        className="text-red-500 text-sm mt-2 hover:underline"
                        onClick={() =>
                          handle_item_remove_cart_list(cartList_result?.id)
                        }
                      >
                        Remove item
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="border p-6 rounded-lg shadow-md w-full max-w-sm bg-white">
              <h3 className="text-lg font-semibold mb-4">Cart Totals</h3>

              <div className="flex justify-between mb-2">
                <p className="text-gray-600">Subtotal</p>
                <p className="font-semibold">${totalPrice.toFixed(2)}</p>
              </div>

              <div className="flex justify-between mb-2">
                <p className="text-gray-600">Tax & Fee</p>
                <p className="font-semibold">${serviceTax.toFixed(2)}</p>
              </div>

              <div className="flex justify-between font-semibold text-lg mb-4">
                <p>Total</p>
                <p>${grandTotal.toFixed(2)}</p>
              </div>

              <div className="space-y-3 mb-4">
                <label className="flex items-start gap-2 text-sm text-gray-700">
                  <input
                    type="checkbox"
                    className="form-checkbox mt-1 h-5 w-5 text-blue-600"
                    checked={termsChecked}
                    onChange={(e) =>
                      handleCheckboxChange("terms", e.target.checked)
                    }
                  />
                  <span>
                    I accept the{" "}
                    <Link
                      to="/privacy-policy"
                      className="text-blue-600 underline hover:text-blue-800"
                    >
                      Terms & Policies
                    </Link>
                  </span>
                </label>

                <label className="flex items-start gap-2 text-sm text-gray-700">
                  <input
                    type="checkbox"
                    className="form-checkbox mt-1 h-5 w-5 text-blue-600"
                    checked={pricingChecked}
                    onChange={(e) =>
                      handleCheckboxChange("pricing", e.target.checked)
                    }
                  />
                  <span>I accept the pricing</span>
                </label>
                {/* Billing Terms Info */}
                <p className="text-sm text-gray-700 mt-2 leading-snug">
                  <strong>Billing Terms:</strong> This purchase is a{" "}
                  <strong>one-time sale</strong>. Please review the details
                  before proceeding to checkout.
                </p>
              </div>

              {/* <button
                                className={`w-full border py-2 rounded-lg transition font-medium ${termsChecked && pricingChecked
                                        ? "text-blue-600 hover:bg-gray-100 cursor-pointer"
                                        : "text-gray-400 bg-gray-100 cursor-not-allowed"
                                    }`}
                                onClick={() => {
                                    localStorage.setItem("cart_totalPrice", totalPrice);
                                    navigate("/checkout");
                                }}
                                disabled={!(termsChecked && pricingChecked)}
                            >
                                Proceed to Checkout
                            </button> */}

              <button
                className={`w-full border py-2 rounded-lg transition font-medium ${
                  termsChecked && pricingChecked
                    ? "text-blue-600 hover:bg-gray-100 cursor-pointer"
                    : "text-gray-400 bg-gray-100 cursor-not-allowed"
                }`}
                onClick={() => {
                  localStorage.setItem("cart_totalPrice", totalPrice);
                  navigate("/checkout");
                }}
                disabled={!(termsChecked && pricingChecked)}
              >
                Proceed to Checkout
              </button>
            </div>
          </div>
        </div>
      ) : hasCheckedCart && showEmptyMessage ? (
        <div className="flex flex-col items-center justify-center h-96">
          <h1 className="text-center text-4xl font-semibold mt-10">
            Your cart is currently empty!
          </h1>
        </div>
      ) : (
        <div className="flex items-center justify-center h-96">
          <p className="text-xl">Loading your cart...</p>
        </div>
      )}

      {/*  */}
      <Footer />
    </>
  );
};

export default Cart;
